import {
  ME,
  LOGOUT,
  SELECT_LOCALE,
  GET_ACCESS_CODE,
  UPDATE_USERNAME,
  UPDATE_ACCOUNT_PIN
} from 'shared/actions/types';

import {
  me as meSvc,
  login as loginSvc,
  logout as logoutSvc,
  verify2FACode as verify2FACodeSvc,
  updateMe as updateMeSvc,
  getAccessCode as getAccessCodeSvc,
  passwordResetLogin as passwordResetLoginSvc
} from 'shared/services/user';

export const me = () => async dispatch => {
  try {
    let user = await meSvc();

    dispatch({
      type: SELECT_LOCALE,
      payload: user?.locale
    })

    dispatch({
      type: ME,
      payload: user
    });

    return user;

  } catch(err) {
    // this is intended to silently fail when the user isn't logged in
    console.error(err);
  }
}

export const login = (email, password) => async dispatch => {
  let user = await loginSvc(email, password);

  dispatch({
    type: ME,
    payload: user
  });

  return user;
}

export const logout = () => async dispatch => {
  await logoutSvc();

  dispatch({
    type: LOGOUT
  });
}

export const verify2FACode = params => async dispatch => {
  let user = await verify2FACodeSvc(params);

  dispatch({
    type: ME,
    payload: user
  });

  return user;
}

export const getAccessCode = () => async dispatch => {
  let accessCode = await getAccessCode();

  dispatch({
    type: GET_ACCESS_CODE,
    payload: accessCode
  });
}

export const updateName = name => dispatch => {
  dispatch({
    type: UPDATE_USERNAME,
    payload: name
  });
}

export const updatePin = pin => dispatch => {
  dispatch({
    type: UPDATE_ACCOUNT_PIN,
    payload: pin
  });
}

export const passwordResetLogin = token => async dispatch => {
  let params = { token };
  let user = await passwordResetLoginSvc(params);

  dispatch({
    type: ME,
    payload: user
  });

  return user;
}
